// images
import blogImg1 from "../images/blog-details/img-1.jpg";
import blogImg2 from "../images/blog-details/img-2.jpg";
import blogImg3 from "../images/blog-details/img-3.jpg";




const blogs = [
    {
        id: '1',
        title: 'Many publishing and web page editors model.',
        screens: blogImg1,
        description: 'It was popularised in the with the release of letraset sheets containing passages versions.',
        author: 'Marilou Kelleher',
        authorTitle:'Sineor Consultant',
        create_at: '25 Dec, 2020',
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: ' Many Dev development and web Design editors model.',
        screens: blogImg2,
        description: 'It was popularised in the with the release of letraset sheets containing passages versions.',
        author: 'Konal Biry',
        authorTitle:'Creative Director',
        create_at: '13 Dec,2022',
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'The standard chunk of used since the interested.',
        screens: blogImg3,
        description: 'It was popularised in the with the release of letraset sheets containing passages versions.',
        author: 'Aliza Anny',
        authorTitle:'Art Director',
        create_at: '22 Dec,2022',
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '2',
        title: 'Many publishing and web page editors model.',
        screens: blogImg2,
        description: 'It was popularised in the with the release of letraset sheets containing passages versions.',
        author: 'Konal Biry',
        authorTitle:'Creative Director',
        create_at: '13 Dec,2022',
        comment:'80',
        blClass:'format-standard-image',
    },
];
export default blogs;